import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, TabBar, Tabs, TabView } from '@salecycle/ui-component-library';
import {
  RcsTemplateEditorTabs,
  useRcsTemplateEditorDispatch,
  useRcsTemplateEditorState,
} from '../context/useRcsTemplateEditorContext';
import { RcsConfigView } from './RcsConfigView';
import { RcsSnapshotEditorView } from './RcsSnapshotEditorView';
import { RcsVersionHistoryView } from './RcsVersionHistoryView';
import { LeftPaneContent, RcsTabsWrapper } from './style';

export const RcsTemplateEditorLeftPane: React.FC = () => {
  const { activeTab } = useRcsTemplateEditorState();
  const dispatch = useRcsTemplateEditorDispatch();
  const { t } = useTranslation(['designs']);

  const handleTabChange = (tabId: string) => {
    dispatch({ type: 'SET_ACTIVE_TAB', payload: { tab: tabId as RcsTemplateEditorTabs } });
  };

  return (
    <LeftPaneContent data-testid="RcsTemplateEditorLeftPane">
      <RcsTabsWrapper>
        <Tabs selectedTabId={activeTab} onSelectedTabChanged={handleTabChange} fillHeight>
          <TabBar borderVariation="clean">
            <Tab tabId={RcsTemplateEditorTabs.templateForm}>{t('designs:rcsTemplateEditor.tabs.rcsTemplate')}</Tab>
            <Tab tabId={RcsTemplateEditorTabs.snapshots}>{t('designs:rcsTemplateEditor.tabs.snapshots')}</Tab>
            <Tab tabId={RcsTemplateEditorTabs.versionHistory}>{t('designs:rcsTemplateEditor.tabs.versionHistory')}</Tab>
          </TabBar>
          <TabView tabId={RcsTemplateEditorTabs.templateForm}>
            <RcsConfigView />
          </TabView>
          <TabView tabId={RcsTemplateEditorTabs.snapshots}>
            <RcsSnapshotEditorView />
          </TabView>
          <TabView tabId={RcsTemplateEditorTabs.versionHistory}>
            <RcsVersionHistoryView />
          </TabView>
        </Tabs>
      </RcsTabsWrapper>
    </LeftPaneContent>
  );
};
